// Registre del Service Worker del portal (CURRENT_TASK.md §10). S'aplica
// només a l'scope "/Control_Horari/": mai afecta la resta de l'ERP, encara
// que el fitxer es serveixi des de l'arrel pública (public/).
export function chRegistrarServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw-control-horari.js`, { scope: `${process.env.PUBLIC_URL}/Control_Horari/` })
      .catch(() => {
        // Si el navegador no el permet registrar (p. ex. mode privat molt
        // restrictiu), el portal continua funcionant en línia amb normalitat;
        // només es perd la càrrega de la interfície sense connexió.
      });
  });
}
